import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-slate-500 text-sm animate-pulse">Checking session…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
}
